module.exports = __webpack_public_path__ + "media/bridge_reference1.55fced39.mp3";